import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {REACTIONS} from './consts';
import {hasUserReacted, getListOfReactingUsers} from './helpers';
import type {ReactingUser, Reaction} from './types';

import styles from './reaction-button.module.css';

type Props = {
    reaction: Reaction;
    reactingUsers: ReactingUser[];
    currentUserId: string;
    onClick: () => void;
    isSmall?: boolean;
};

export function ReactionButton(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    }, []);

    return (
        <button
            onClick={props.onClick}
            data-tip={getListOfReactingUsers(props.reactingUsers, props.currentUserId)}
            data-delay-show='300'
            data-event='mouseenter focus'
            data-event-off='mouseleave blur click'
            className={classnames({
                [styles['reaction-button']]: true,

                [styles['reaction-button--reacted']]: hasUserReacted(
                    props.reactingUsers,
                    props.currentUserId
                ),

                [styles['reaction-button--small']]: props.isSmall,
            })}
        >
            <div>{props.reactingUsers.length}</div>
            {/* @ts-expect-error */}
            <div>{REACTIONS[props.reaction].unicode}</div>
        </button>
    );
}
